import React from "react";
import PropTypes from "prop-types";
import { createMuiTheme, TextField, ThemeProvider } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { makeStyles } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles({
  inputTextField: { padding: 1, fontSize: 12 },
  labelTextField: { padding: 1, fontSize: 12, top: -8 },
  shrink: { transform: "translate(0, 9.5px) scale(0.75)" },
});

function EditNumberField(props) {
  const classes = useStyles();
  const [beginValue, setBeginValue] = React.useState(props.value);
  const [value, setValue] = React.useState(props.value);
  const inputRef = React.useRef(null);
  let inputProps = {};
  if (props.inputProps != null) {
    inputProps = props.inputProps;
  }

  const handleKeyDown = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    if (e.key === "Enter") {
      inputRef.current.blur();
    }
  };

  const getField = (write) => {
    return (
      <ThemeProvider theme={theme}>
        <TextField
          helperText={props.helperText}
          error={value !== beginValue}
          color={"primary"}
          inputRef={inputRef}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onKeyDown={handleKeyDown}
          disabled={props.disabled !== null ? props.disabled || !write : !write}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onBlur={(e) => {
            if (beginValue.toString() !== e.target.value) {
              /// float compared to string
              props.onBlur(e.target.value, setBeginValue);
            }
          }}
          fullWidth
          variant={props.variant != null ? props.variant : "outlined"}
          type="number"
          size="small"
          InputProps={{ ...inputProps, classes: { input: classes.inputTextField } }}
          InputLabelProps={{ classes: { root: classes.labelTextField, shrink: classes.shrink } }}
          label={props.label}
          value={value}
          style={props.style}
        />
      </ThemeProvider>
    );
  };

  return props.authorizationField ? (
    <AuthorizationWrapper
      permission={props.authorizationField}
      child={(write) => {
        return getField(write);
      }}
    />
  ) : (
    getField(true)
  );
}

EditNumberField.propTypes = {
  authorizationField: PropTypes.string,
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  inputProps: PropTypes.object,
};

export default EditNumberField;
